<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">The results of a set of measurements (in weight %) are:</p>

      <ul class="mb-5">
        <li class="ml-4">
          <number-value :value="x1" />
        </li>
        <li class="ml-4">
          <number-value :value="x2" />
        </li>
        <li class="ml-4">
          <number-value :value="x3" />
        </li>
        <li class="ml-4">
          <number-value :value="x4" />
        </li>
        <li class="ml-4">
          <number-value :value="x5" />
        </li>
      </ul>

      <p class="mb-2">
        For the above set of data, calculate the mean, the standard deviation, the relative standard
        deviation, the coefficient of variation, and the spread.
      </p>

      <calculation-input
        v-model="inputs.mean"
        class="mb-5"
        prepend-text="$\text{a) Mean}:$"
        :disabled="!allowEditing"
      />

      <calculation-input
        v-model="inputs.stDev"
        class="mb-5"
        prepend-text="$\text{b) Standard Deviation}:$"
        :disabled="!allowEditing"
      />

      <calculation-input
        v-model="inputs.RSD"
        class="mb-5"
        prepend-text="$\text{c) Relative standard deviation}:$"
        :disabled="!allowEditing"
      />

      <calculation-input
        v-model="inputs.coefVar"
        class="mb-5"
        prepend-text="$\text{d) Coefficient of variation}:$"
        :disabled="!allowEditing"
      />

      <calculation-input
        v-model="inputs.spread"
        class="mb-5"
        prepend-text="$\text{e) Spread}:$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'ChemUPEI2210A1Q1',
  components: {
    ChemicalLatex,
    CalculationInput,
    NumberValue,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        mean: null,
        stDev: null,
        RSD: null,
        coefVar: null,
        spread: null,
      },
    };
  },
  computed: {
    x1() {
      return this.taskState.getValueBySymbol('x1').content;
    },
    x2() {
      return this.taskState.getValueBySymbol('x2').content;
    },
    x3() {
      return this.taskState.getValueBySymbol('x3').content;
    },
    x4() {
      return this.taskState.getValueBySymbol('x4').content;
    },
    x5() {
      return this.taskState.getValueBySymbol('x5').content;
    },
  },
};
</script>
